import axios, { AxiosError } from "axios";
import { useMutation, UseMutationOptions } from "react-query";

import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { POST_ADD_NOTE } from "./constants";

export interface AddNoteResponse {}

export function usePostCallAddNote(
  eventId: string,
  options: UseMutationOptions<
    AddNoteResponse,
    AxiosError<{ errorDescription: string }>,
    {}
  >
) {
  const addNoteURL = `${getAppConfigSetting("apiUrl")}${POST_ADD_NOTE(
    eventId
  )}`;

  const postAddCallNote = async (note: string) => {
    const { data } = await axios.post(
      addNoteURL,
      { note },
      {
        withCredentials: true,
      }
    );
    return data as AddNoteResponse;
  };

  return useMutation(postAddCallNote, {
    retry: false,
    ...options,
  });
}
